import React from 'react';
import GenericCRUDPage from '../../components/GenericCRUDPage';
import { FormField, Input, Textarea, Badge } from '../../components/UI';
import { roleService } from '../../api/services';
import { toJalali } from '../../utils/jalali';

const PERMISSIONS = [
  'admin', 'medicines_view', 'medicines_create', 'medicines_edit',
  'inventory_view', 'inventory_manage', 'purchases_view', 'purchases_create', 'purchases_edit',
  'sales_view', 'sales_create', 'customers_manage', 'suppliers_manage',
  'patients_manage', 'doctors_manage', 'prescriptions_create', 'prescriptions_edit',
  'users_view', 'users_create', 'users_edit', 'roles_manage', 'branches_manage',
  'accounting_view', 'accounting_manage', 'expenses_manage', 'reports_view', 'audit_view',
];

const RoleFormFields = ({ form: { register, watch, setValue } }) => {
  const selected = watch('permissions') || [];
  const toggle = (perm) => {
    if (selected.includes(perm)) setValue('permissions', selected.filter(p => p !== perm));
    else setValue('permissions', [...selected, perm]);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <FormField label="Role Name" required>
          <Input {...register('name', { required: 'Required' })} placeholder="e.g. Pharmacist" />
        </FormField>
        <FormField label="Description">
          <Input {...register('description')} placeholder="Role description" />
        </FormField>
      </div>
      <div>
        <label className="text-sm font-medium text-gray-700 block mb-2">Permissions</label>
        <div className="grid grid-cols-3 gap-2 p-3 bg-gray-50 rounded-lg max-h-64 overflow-y-auto">
          {PERMISSIONS.map(perm => (
            <label key={perm} className="flex items-center gap-2 cursor-pointer py-1">
              <input type="checkbox" checked={selected.includes(perm)} onChange={() => toggle(perm)} className="rounded" />
              <span className="text-xs text-gray-700">{perm.replace(/_/g, ' ')}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

const columns = [
  { key: 'name', label: 'Role Name', sortable: true },
  { key: 'description', label: 'Description' },
  { key: 'permissions', label: 'Permissions', render: (v) => `${v?.length || 0} permissions` },
  { key: 'isActive', label: 'Status', render: (v) => <Badge color={v ? 'green' : 'gray'}>{v ? 'Active' : 'Inactive'}</Badge> },
  { key: 'createdAt', label: 'Created', render: (v) => toJalali(v) },
];

export default function RolesPage() {
  return (
    <GenericCRUDPage
      title="Roles & Permissions"
      subtitle="Manage user roles and access"
      service={roleService}
      entityName="Role"
      columns={columns}
      FormFields={RoleFormFields}
      defaultValues={{ name: '', description: '', permissions: [] }}
      modalSize="lg"
    />
  );
}
